import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Terms & Conditions</h1>
          <p className="text-gray-600">Effective date: January 1, 2024</p>
        </div>

        <div className="prose prose-gray max-w-none">
          <p className="text-gray-700 leading-relaxed mb-6">
            For the purpose of these Terms and Conditions, The term "we", "us", "our" used anywhere on this page shall mean Aashritha E Solutions, whose registered/operational office is Ground Floor, Surabhi Lotus Building, Ambalpady Highway Junction, Karnataka 576101. "you", "your", "user", "visitor" shall mean any natural or legal person who is visiting our website and/or agreed to purchase from us.
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            Your use of the website and/or purchase from us are governed by following Terms and Conditions:
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Website Terms of Use</h2>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Content Changes</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            The content of the pages of this website is subject to change without notice.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Warranties and Disclaimers</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Use at Your Own Risk</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through our website and/or product pages meet your specific requirements.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Intellectual Property</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Our website contains material which is owned by or licensed to us. This material includes, but are not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Trademarks</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            All trademarks reproduced in our website which are not the property of, or licensed to, the operator are acknowledged on the website.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Unauthorized Use</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">External Links</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            From time to time our website may also include links to other websites. These links are provided for your convenience to provide further information.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Linking to Our Website</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            You may not create a link to our website from another website or document without Aashritha E Solutions's prior written consent.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Governing Law</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Any dispute arising out of use of our website and/or purchase with us and/or any engagement with us is subject to the laws of India.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Transaction Limitations</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            We, shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Information</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            If you have any questions about these Terms and Conditions, please contact us:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700">
            <li>By email: aashritha756@yahoo.com</li>
            <li>By phone: +91 9448128756</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Terms;